<template>
  <div>
    <div class="drafts oa-layout-content">
      <a-table :pagination="false" :columns="columns" :data-source="data">
        <span slot="num" slot-scope="text">{{ text }}台</span>
        <div slot="action">
          <a-button type="link" class="btn-link" @click="add()">
            编辑
          </a-button>
          <a-divider type="vertical" />
          <a-button type="link" class="btn-link"> 删除 </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination :default-current="1" :total="500" @change="pageChange" />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'lot',
    key: 'lot'
  },
  {
    title: '审计文号',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true
  },
  {
    title: '被审计单位',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: '审计报告时间',
    dataIndex: 'age',
    key: 'age'
    // width: 80,
  },

  {
    title: '问题性质',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '问题描述',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '是否整改',
    dataIndex: 'time',
    key: 'time'
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'center'
  }
]

const data = [
  {
    key: '1',
    time: 2124343,
    name: '赵丽颖',
    title: '100块钱',
    age: 'pdf',
    num: 46,
    lot: 66
  },
  {
    key: '2',
    name: 42,
    time: 42333,
    title: '一张图',
    age: 'jpg',
    address: '外星人222',
    num: 16,
    lot: 36
  },
  {
    key: '333',
    name: 4299,
    time: 42333,
    title: '文档',
    age: 'txt',
    address: '电竞座椅',
    num: '62',
    lot: 63
  }
]

export default {
  data() {
    return {
      Form: {
        serialNumber: ''
      },
      data,
      columns
    }
  },
  methods: {
    add() {},
    pageChange(pageNumber) {
      console.log('Page: ', pageNumber)
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/standingBook/drafts.vue